import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormInput from '../../../../../library/form/components/FormInput';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormCheckbox from '../../../../../library/form/components/FormCheckbox';
import withView from '../../../../cmn/docAutomation/withView';
import { UiView, UiViewContent, UiGridColTwo, UiCol } from "../../../../../library/layout/Index";

const ProdMatrixHeader = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null)

    // console.log("Matrix data ProdMatrixHeader", viewData);

    return (
        <UiView>
            <UiViewContent>
                <UiGridColTwo>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requireD1" }} value="Have Variation 1" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey="" action={{
                                    InputType: "onOff", paramName: "requireD1", actionId: "refresh", refreshMode:"dep", actionParam: { actionType: "updateMatrixHeader" }
                                }} />
                                <span className='uiLblInLine'>:</span>
                                <FormInput format="#" formObject={formObject} rowKey="" className="uiInput"
                                    action={{
                                        InputType: "ac", paramName: "variation1", 
                                        acMethod: "Category", 
                                        acDepCtrl: { group: 'PROD_MATRIX' },
                                        actionId: "refresh", refreshMode:"dep",
                                        actionParam: { actionType: "updateMatrixHeader" }
                                    }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requireD2" }} value="Have Variation 2" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey="" action={{
                                    InputType: "onOff",
                                    paramName: "requireD2", actionId: "refresh", refreshMode:"dep", actionParam: { actionType: "updateMatrixHeader" }
                                }} />
                                <span className='uiLblInLine'>:</span>
                                <FormInput format="#" formObject={formObject} rowKey="" className="uiInput"
                                    action={{
                                        InputType: "ac", paramName: "variation2", 
                                        acMethod: "Category", 
                                        acDepCtrl: { group: 'PROD_MATRIX' },
                                        actionId: "refresh", refreshMode:"dep",
                                        actionParam: { actionType: "updateMatrixHeader" }
                                    }}
                                />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul >
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bom" }} value="Default BOM" />
                                </span>
                                <FormInput formObject={formObject} rowKey=""
                                    action={{ InputType: "ac", actionId: "refresh", paramName: "bomName", acMethod: "TargetItemBom", 
                                    acDepCtrl: { 'dparam': '%dataList.valLDT', 'tdtId': '%dataList.tdtId',  'tdId': '%dataList.tdId'},
                                    actionParam:{actionType: "updateMatrixHeader"} }} className='uiInput uiSpacerH10' style={{width:'200px'}}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalQty" }} value="Total Quantity" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalQty" }} />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColTwo>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdMatrixHeader, "prodMatrix", "prodMatrixChart");
